export default __webpack_public_path__ + "static/media/tiivii-guia-escritorio-3.42c51d1a.png";